
export const boolOptions = [
    { value: 'True', label: 'Sim' },
    { value: 'False', label: 'Não' },
]